import React from "react";
import PropTypes from "prop-types";

function ErrorMessage({ message }) {
    return <>{message && <span className="error-message">{message}</span>}</>;
}

ErrorMessage.propTypes = {
    message: PropTypes.string
}

export default ErrorMessage;
